module.exports = __webpack_public_path__ + "static/color element-21-25cb43b977ca2e8796b2ee0ad4602f5c.png";